import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './reality-check-modal.magic.css.js';
import script from './reality-check-modal.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reality-check-modal",attrs:{"part":"reality-check-modal","data-v-test-id":"reality-check-modal"}},[_c('div',{staticClass:"wrapper",attrs:{"part":"wrapper","data-v-test-id":"wrapper"}},[_c('magic-ui-text',{staticClass:"content",attrs:{"part":"content","content":_vm.$t('reality-check-modal.corex.text', { time: _vm.time })}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"content",attrs:{"part":"content","content":_vm.$t('reality-check-modal.corex.spent.time.text' , { amountSpent: _vm.amountSpent, currency: _vm.currency })}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"content",attrs:{"part":"content","content":_vm.$t('reality-check-modal.corex.net.position', { netPosition: _vm.parseNetPosition, currency: _vm.currency })}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"content",attrs:{"part":"content","content":_vm.$t('reality-check-modal.corex.paragraph')}}),_vm._v(" "),_c('div',{staticClass:"link-content"},[_c('magic-ui-text',{staticClass:"history-content",attrs:{"part":"content","content":_vm.$t('reality-check-modal.corex.history.link')}}),_vm._v(" "),_c('magic-ui-link',{staticClass:"link",attrs:{"variant":"primary","to":_vm.RoutablePage.WALLET_HISTORY,"target":"_blank"}},[_vm._v("\n                "+_vm._s(_vm.$t('reality-check-modal.link.text'))+"\n            ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"action",attrs:{"part":"action"}},[_c('magic-ui-text',{staticClass:"content",attrs:{"part":"content","content":_vm.$t('reality-check-modal.corex.buttons.label')}}),_vm._v(" "),_c('magic-ui-button',{staticClass:"button",attrs:{"wide":"","variant":"primary","part":"button","data-v-test-id":"reality-check-continue","loading":_vm.isLoading},domProps:{"innerHTML":_vm._s(_vm.$t('reality-check-modal.button.continue'))},on:{"click":_vm.continueOption}}),_vm._v(" "),_c('magic-ui-button',{staticClass:"button",attrs:{"wide":"","hollow":"","variant":"primary","part":"button","data-v-test-id":"reality-check-stop","loading":_vm.isLoadingStop},domProps:{"innerHTML":_vm._s(_vm.$t('reality-check-modal.button.stop'))},on:{"click":_vm.stopRealityCheck}})],1)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-45b4f33b_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-45b4f33b";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
